import React, { useState, useEffect } from "react";
import Slider1 from '../../assets/slider-1.webp';
import Slider2 from '../../assets/slider-2.webp';

const Slider = () => {
  const slides = [
    {
      image: Slider1,
      title: "24/7 Truck Road Services Near Me",
      subtitle: "Professional Mechanics & Towing Experts Just a Call Away",
      phone: "+1 (800) 805-7820",
    },
    {
      image: Slider2,
      title: "Truck Roadside Help Near Me",
      subtitle: "Immediate Support When Your Truck Needs It Most",
      phone: "+1 (800) 805-7820",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const nextSlide = () =>
    setCurrentIndex((prev) => (prev + 1) % slides.length);

  const prevSlide = () =>
    setCurrentIndex((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <div className="slider">
      <div
        className="slider-wrapper"
        style={{ transform: `translateY(-${currentIndex * 100}%)` }}
      >
        {slides.map((slide, index) => (
          <div className="slide" key={index}>
            <img src={slide.image} alt={`Slide-${index}`} />

            {/* Dark Overlay */}
            <div className="overlay"></div>

            {/* Text */}
            <div className="slide-text">
              <div class="border_line"></div>
              <h2 className={currentIndex === index ? "fade-in" : ""}>{slide.title}</h2>
              <p>{slide.subtitle}</p>
              <h4 className={currentIndex === index ? "slider_phone fade-in" : ""}>
                {slide.phone}
              </h4>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation */}
      <div className="slider-nav">
        <button onClick={prevSlide}>↑ Previous</button>
        <button onClick={nextSlide}>↓ Next</button>
      </div>
    </div>
  );
};

export default Slider;
